import { api } from 'src/services';
import generateLink from './generateLink';
import getDynamicLinks from './getDynamicLinks';
import createDynamicLink from './createDynamicLink';
import deleteDynamicLink from './deleteDynamicLink';
import getActivityLogs from './getActivityLogs';

export const authApis = api.injectEndpoints({
    endpoints: (build) => ({
        generateLink: generateLink(build),
        getDynamicLinks: getDynamicLinks(build),
        createDynamicLink: createDynamicLink(build),
        deleteDynamicLink: deleteDynamicLink(build),
        getActivityLogs: getActivityLogs(build),
    }),
    overrideExisting: true,
});

export const { 
    useGenerateLinkMutation,
    useLazyGetDynamicLinksQuery,
    useCreateDynamicLinkMutation,
    useDeleteDynamicLinkMutation,
    useGetActivityLogsQuery,
    useLazyGetActivityLogsQuery
} = authApis;